import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function SchoolErp() {
    const [modalInfo, setModalInfo] = useState({ isOpen: false, imgSrc: "", caption: "" });

    const openModal = (src, caption) => {
        setModalInfo({ isOpen: true, imgSrc: src, caption });
    };

    const closeModal = () => {
        setModalInfo({ isOpen: false, imgSrc: "", caption: "" });
    };

    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section className="inr-header">
                <div className="container">
                    <div className="inr-header-content">
                        <h1 className="title">School ERP</h1>
                        <ul className="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> School ERP</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>School ERP</h1>
                        </div>

                        <div className="col-lg-9 col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <p className="details">
                                        Entab Infotech Pvt Ltd., a company formed in 2000 and serving the school with automation
                                        technologies has evolved out as the best service provider through their advanced{" "}
                                        <a href="https://www.entab.in/school-management-erp.html"><b>ERP Software:</b></a>{' '}
                                        'CampusCare®' and communication tools. We are also proud to be associated with them for
                                        managing the data of students, exam, fees, staff and their accounts etc in addition to the{" "}
                                        <a href="https://www.entab.in/school-communication-portals.html"><b> communication portal</b></a> and{" "}
                                        <a href="https://www.entab.in/mobile-apps.html"><b> mobile apps</b></a>.<br />
                                        <br />
                                        The entire system is strengthening the academic of the students and preparing responsible
                                        staff and students. Together the reputation of the school grows higher. We value the relation
                                        with <a href="https://www.entab.in/"><b>Entab: CampusCare®</b></a> and look forward to
                                        receive the much more in technological front.
                                    </p>
                                </div>
                            </div>
                            <div className="p-3"></div>
                            <div className="row">
                                <div className="col-md-4">
                                    <img
                                        id="myImg"
                                        src="https://webapi.entab.info/api/image/SMNSB/public/images/Manage-Data.gif"
                                        alt="School Management System, Management ERP Software"
                                        className="animation img-fluid "
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            openModal(
                                                "https://webapi.entab.info/api/image/SMNSB/public/images/Manage-Data.gif",
                                                "Manage Data"
                                            )
                                        }
                                    />
                                    <h4 className="imgheading">
                                        <a href="https://www.entab.in/school-management-erp.html">Manage Data</a>
                                    </h4>
                                </div>

                                <div className="col-md-4">
                                    <img
                                        id="myImg1"
                                        src="https://webapi.entab.info/api/image/SMNSB/public/images/Parent-Portal.gif"
                                        alt="Entab Parent Portal, School Software"
                                        className="animation img-fluid"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            openModal(
                                                "https://webapi.entab.info/api/image/SMNSB/public/images/Parent-Portal.gif",
                                                "Parent Portal"
                                            )
                                        }
                                    />
                                    <h4 className="imgheading">
                                        <a href="https://www.entab.in/school-communication-portals.html#PPC">Parent Portal</a>
                                    </h4>
                                </div>

                                <div className="col-md-4">
                                    <img
                                        id="myImg2"
                                        src="https://webapi.entab.info/api/image/SMNSB/public/images/communication.gif"
                                        alt="smnsbokaro"
                                        className="animation img-fluid"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            openModal(
                                                "https://webapi.entab.info/api/image/SMNSB/public/images/communication.gif",
                                                "Communication Portal"
                                            )
                                        }
                                    />
                                    <h4 className="imgheading">
                                        <a href="https://www.entab.in/school-communication-portals.html#PPC">Communication Portal</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <center>
                                <a href="https://www.entab.in/mobile-apps.html">
                                    <img
                                        src="https://webapi.entab.info/api/image/SMNSB/public/images/Mobile-slides.gif"
                                        className="img-fluid"
                                        alt="School ERP Software, Mobile App, School Management Software, Software for School"
                                    />
                                </a>
                            </center>
                        </div>

                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Modal */}
            {modalInfo.isOpen && (
                <div
                    className="animodal"
                    style={{
                        display: 'block',
                        position: 'fixed',
                        zIndex: 1000,
                        paddingTop: '100px',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        overflow: 'auto',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                    }}
                    onClick={closeModal}
                >
                    <span
                        className="closearow"
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '35px',
                            color: '#f1f1f1',
                            fontSize: '40px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={closeModal}
                    >
                        &times;
                    </span>
                    <img
                        className="animodal-content"
                        src={modalInfo.imgSrc}
                        alt={modalInfo.caption}
                        style={{
                            margin: 'auto',
                            display: 'block',
                            maxWidth: '80%',
                            maxHeight: '80vh',
                            borderRadius: '8px',
                        }}
                    />
                    <div
                        id="anicaption"
                        style={{
                            margin: 'auto',
                            display: 'block',
                            width: '80%',
                            textAlign: 'center',
                            color: '#ccc',
                            padding: '10px 0',
                            fontSize: '18px',
                        }}
                    >
                        <a
                            href={
                                modalInfo.caption === "Manage Data"
                                    ? "https://www.entab.in/school-management-erp.html"
                                    : modalInfo.caption === "Parent Portal"
                                        ? "https://www.entab.in/school-communication-portals.html#PPC"
                                        : "https://www.entab.in/school-communication-portals.html#PPC"
                            }
                            style={{ color: '#ccc', textDecoration: 'underline' }}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {modalInfo.caption}
                        </a>
                    </div>
                </div>
            )}
            {/* Footer */}
            <Footer />
        </>
    );
}
export default SchoolErp;
